import { Outlet } from 'react-router-dom';
import { AuthEventData } from '@aws-amplify/ui';
import { AmplifyUser } from '@aws-amplify/ui/dist/types/types/authenticator/user';

import Header from 'components/header';
import ContactSupportButton from 'components/contact-support-button';

function HeaderLayout({
  user,
  signOut
}: {
  user: AmplifyUser | undefined;
  signOut: ((data?: AuthEventData | undefined) => void) | undefined;
}): JSX.Element {
  return (
    <main className="pb-24">
      <Header user={user} signOut={signOut} />
      <div className="px-8">
        <Outlet />
      </div>
      {user != null && <ContactSupportButton />}
    </main>
  );
}

export default HeaderLayout;
